<template>
  <section>
    <div class="row">
      <!-- Member -->
      <div class="col-3">
        <div class="row">
          <div class="col custom-member">
            <img :src="avatar" />
            <span>{{ sender }}</span>
          </div>
          <div class="col-4">
            <div
              v-if="parseInt(senderId) === parseInt(profile.id) || isCoach"
              class="custom-edit-delete"
            >
              <button class="btn btn-link" @click="editFeedPost()">edit</button>
              <span class="ms-1 me-1">|</span>
              <button class="btn btn-link" @click="deleteFeedPost()">
                delete
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col custom-created">
            <span>{{ created }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-4 custom-like">
            <div v-if="numLikes > 0" :title="likedMembers" class="custom-heart">
              <i class="fas fa-heart"></i>
              <span>{{ numLikes }}</span>
            </div>
            <button v-if="anyLikes" class="btn btn-link" @click="unlike">
              <i class="far fa-thumbs-down custom-thumbs"></i>Unlike
            </button>
            <button v-else class="btn btn-link" @click="like">
              <i class="far fa-thumbs-up custom-thumbs"></i>Like
            </button>
          </div>
          <div class="col"></div>
        </div>
      </div>
      <!-- Message / Images / Video Links -->
      <div class="col">
        <p v-if="message" class="custom-message">{{ message }}</p>
        <hr v-if="message && images.length > 0" />
        <div v-for="image of images" :key="image.id">
          <a class="custom-image-link" @click="showImage(image.Uri)">
            <img :src="image.Uri" class="custom-image" />
          </a>
        </div>
        <hr v-if="images.length > 0 && videos.length > 0" />
        <div v-for="video of videos" :key="video.id">
          <button class="btn btn-link" @click="showVideo(video.video_url)">
            <i class="fas fa-video custom-video-icon"></i>
            <span>{{ processVideoLink(video.video_url) }}</span>
          </button>
        </div>
      </div>
      <!-- Comments -->
      <div class="col-4 custom-comments-wrapper">
        <div class="row mb-2">
          <div class="col custom-comments">
            <span>Comments</span>
            <a @click="addComment">Add</a>
          </div>
        </div>
        <div
          v-for="comment of comments"
          :key="comment.id"
          class="row custom-comment"
        >
          <div class="col">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col custom-member">
                    <img :src="processAvatar(comment.sender)" />
                    <span>{{ processName(comment.sender) }}</span>
                  </div>
                  <div
                    v-if="
                      parseInt(comment.sender_id) === parseInt(profile.id) ||
                      isCoach
                    "
                    class="col-3 custom-edit-delete"
                  >
                    <button class="btn btn-link" @click="editComment(comment)">
                      edit
                    </button>
                    <span class="ms-1 me-1">|</span>
                    <button
                      class="btn btn-link"
                      @click="deleteComment(comment.id)"
                    >
                      delete
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col custom-created">
                    <span>{{ processCreated(comment) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p>{{ comment.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'feed-record',
  props: {
    feedPost: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('users', ['profile']),
    id() {
      let _data = null
      if (this.feedPost) {
        _data = this.feedPost.id
      }
      return _data
    },
    senderId() {
      let _data = null
      if (this.feedPost) {
        if (this.feedPost.sender) {
          _data = this.feedPost.sender.id
        }
      }
      return _data
    },
    sender() {
      let _data = null
      if (this.feedPost) {
        if (this.feedPost.sender) {
          _data = this.feedPost.sender.name.trim()
          if (this.feedPost.sender.user_detail) {
            if (this.feedPost.sender.user_detail.NickName) {
              if (this.feedPost.sender.user_detail.NickName != '') {
                _data += ` (${this.feedPost.sender.user_detail.NickName.trim()})`
              }
            }
          }
        }
      }
      return _data
    },
    avatar() {
      let _data = null
      if (this.feedPost.sender) {
        _data = this.feedPost.sender.user_detail.Avatar
      }
      return _data
    },
    created() {
      let _data = null
      if (this.feedPost) {
        let createdAt = moment.utc(this.feedPost.created_at)
        let ago = createdAt.fromNow()
        let checkFor = ['second', 'minute', 'hour']
        let isThere = checkFor.some((x) => ago.includes(x))
        if (isThere) {
          _data = ago
        } else {
          _data = `${ago}, ${createdAt.format('MM/DD/YYYY h:mm a')}`
        }
      }
      return _data
    },
    message() {
      let _data = null
      if (this.feedPost) {
        _data = this.feedPost.text.trim()
      }
      return _data
    },
    images() {
      let _data = []
      if (this.feedPost) {
        _data = this.feedPost.images
      }
      return _data
    },
    videos() {
      let _data = []
      if (this.feedPost) {
        _data = this.feedPost.videos
      }
      return _data
    },
    numLikes() {
      let _data = 0
      if (this.feedPost) {
        _data = this.feedPost.likes.length
      }
      return _data
    },
    anyLikes() {
      let _data = false
      if (this.feedPost) {
        let found = this.feedPost.likes.find(
          (x) => parseInt(x.user.id) === parseInt(this.profile.id)
        )
        if (found) {
          _data = true
        }
      }
      return _data
    },
    numComments() {
      let _data = 0
      if (this.feedPost) {
        _data = this.feedPost.comments.length
      }
      return _data
    },
    comments() {
      let _data = null
      if (this.feedPost) {
        _data = this.feedPost.comments
      }
      return _data
    },
    likedMembers() {
      let _data = ''
      if (this.feedPost) {
        this.feedPost.likes.forEach((element) => {
          if (_data !== '') {
            _data += ', '
          }
          _data += element.user.name
        })
      }
      return _data
    },
    isCoach() {
      let _is = false
      if (this.profile) {
        if (this.profile.roles) {
          this.profile.roles.forEach((element) => {
            if (
              element.role_id === 2 ||
              element.role_id === 3 ||
              element.role_id === 5
            ) {
              _is = true
            }
          })
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('feed', ['setFeedPostLike']),
    showVideo(url) {
      this.$emit('playVideo', url)
    },
    showImage(url) {
      this.$emit('showImage', url)
    },
    processAvatar(sender) {
      let avatar = null
      if (sender) {
        if (sender.user_detail) {
          avatar = sender.user_detail.Avatar
        }
      }
      return avatar
    },
    processName(sender) {
      let name = null
      if (sender) {
        name = sender.name.trim()
        if (sender.user_detail) {
          if (sender.user_detail.NickName) {
            if (sender.user_detail.NickName != '') {
              name += ` (${sender.user_detail.NickName.trim()})`
            }
          }
        }
      }
      return name
    },
    processCreated(comment) {
      let created = null
      if (comment) {
        let createdAt = moment.utc(comment.created_at)
        let ago = createdAt.fromNow()
        let checkFor = ['second', 'minute', 'hour']
        let isThere = checkFor.some((x) => ago.includes(x))
        if (isThere) {
          created = ago
        } else {
          created = `${ago}, ${createdAt.format('MM/DD/YYYY h:mm a')}`
        }
      }
      return created
    },
    processVideoLink(url) {
      let name = ''
      if (url) {
        let paths = url.split('/').filter((entry) => entry !== '')
        name = paths[paths.length - 1]
      }
      return name
    },
    async like() {
      console.log('Liking', this.feedPost)
      let data = {
        id: this.feedPost.id,
        userId: this.profile.id,
        like: 'true',
      }
      await this.setFeedPostLike(data)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    async unlike() {
      console.log('Unliking', this.feedPost)
      let data = {
        id: this.feedPost.id,
        userId: this.profile.id,
        like: 'false',
      }
      await this.setFeedPostLike(data)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    addComment() {
      console.log('Add Comment', this.feedPost)
      this.$emit('addComment', this.feedPost)
    },
    editComment(data) {
      let comment = this.feedPost.comments.find(
        (x) => parseInt(x.id) === parseInt(data.id)
      )
      console.log('Edit Comment', comment)
      if (comment) {
        this.$emit('editComment', comment)
      }
    },
    deleteComment(id) {
      let comment = this.feedPost.comments.find(
        (x) => parseInt(x.id) === parseInt(id)
      )
      console.log('Delete Comment', comment)
      if (comment) {
        this.$emit('deleteComment', comment.id)
      }
    },
    editFeedPost() {
      this.$emit('editFeed', this.feedPost)
    },
    deleteFeedPost() {
      this.$emit('deleteFeed', this.feedPost.id)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-member {
  img {
    border-radius: 50%;
    float: left;
    width: 40px;
    height: 40px;
  }
  span {
    margin-left: 10px;
    top: 10px;
    position: relative;
  }
}
.custom-created {
  position: relative;
  span {
    font-size: 0.7em;
    font-style: italic;
  }
}
.custom-message {
  padding-bottom: 5px;
}
.custom-heart {
  position: relative;
  display: inline-flex;
}
.custom-image-link {
  cursor: pointer;
}
.custom-image {
}
.custom-like {
  display: inline-flex;
  i {
    color: red;
    font-size: 1.2em;
  }
  span {
    font-size: 0.9em;
    margin-left: 5px;
    padding-top: 6px;
  }
  button {
    font-size: 0.9em;
  }
}
.custom-comments-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
}
.custom-comments {
  display: inline-flex;
  span {
    font-size: 1.1em;
    font-weight: 500;
    text-decoration: underline;
  }
  a {
    margin-left: 10px;
    color: #0d6efd;
    text-decoration: underline;
    cursor: pointer;
  }
  a:hover {
    color: #0a58ca;
  }
}
.custom-comment {
  border-top: 1px solid #e1e1e1e1;
  padding-top: 10px;
}
.custom-video-icon {
  font-size: 1.2em;
  margin-right: 10px;
}
.custom-thumbs {
  color: #0d6efd !important;
  margin-right: 5px;
}
.custom-edit-delete {
  position: relative;
  display: inline-flex;
  span {
    position: relative;
    top: 8px;
  }
}
</style>
